import React from 'react';
import { Search, Filter } from 'lucide-react';

interface Filters {
  status: string;
  nivel: string;
}

interface UserFiltersProps {
  filters: Filters;
  searchTerm: string;
  onFiltersChange: (filters: Filters) => void;
  onSearchChange: (searchTerm: string) => void;
  selectedUsers: number[];
  onBulkStatus: (status: number) => void;
  onBulkDelete: () => void;
}

const UserFilters: React.FC<UserFiltersProps> = ({
  filters,
  searchTerm,
  onFiltersChange,
  onSearchChange,
  selectedUsers,
  onBulkStatus,
  onBulkDelete
}) => {
  return (
    <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-4 sm:p-6 border-2 border-gray-200/50 dark:border-gray-700/50 shadow-soft">
      {/* Header dos filtros */}
      <div className="flex items-center gap-2 mb-4">
        <Filter className="text-primary-600 dark:text-primary-400" size={20} />
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">Filtros e Busca</h3>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {/* Busca */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" size={20} />
          <input
            type="text"
            placeholder="Buscar usuários..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 border-2 border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-primary-500 text-sm transition-colors"
          />
        </div>

        {/* Status Filter */}
        <select
          value={filters.status}
          onChange={(e) => onFiltersChange({...filters, status: e.target.value})}
          className="px-4 py-2.5 border-2 border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-primary-500 text-sm transition-colors"
        >
          <option value="all">Status</option>
          <option value="active">Ativos</option>
          <option value="inactive">Inativos</option>
        </select>

        {/* Nível Filter */}
        <select
          value={filters.nivel}
          onChange={(e) => onFiltersChange({...filters, nivel: e.target.value})}
          className="px-4 py-2.5 border-2 border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-primary-500 text-sm transition-colors"
        >
          <option value="all">Níveis</option>
          <option value="admin">Operador</option>
          <option value="dev">Programador</option>
          <option value="usuario">Gerente</option>
        </select>
      </div>

      {/* Ações em lote */}
      {selectedUsers.length > 0 && (
        <div className="mt-5 p-4 bg-primary-50/50 dark:bg-primary-900/30 rounded-xl border border-primary-200/50 dark:border-primary-700/50">
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-primary-500 dark:bg-primary-400 rounded-full"></div>
              <span className="text-sm font-medium text-primary-700 dark:text-primary-300">
                {selectedUsers.length} usuário(s) selecionado(s)
              </span>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <button
                onClick={() => onBulkStatus(1)}
                className="btn btn-sm btn-success w-full sm:w-auto flex items-center justify-center gap-2 hover:bg-emerald-600 transition-colors"
              >
                <span className="w-2 h-2 bg-white rounded-full"></span>
                Ativar
              </button>
              <button
                onClick={() => onBulkStatus(0)}
                className="btn btn-sm btn-warning w-full sm:w-auto flex items-center justify-center gap-2 hover:bg-amber-600 transition-colors"
              >
                <span className="w-2 h-2 bg-white rounded-full"></span>
                Desativar
              </button>
              <button
                onClick={onBulkDelete}
                className="btn btn-sm btn-danger w-full sm:w-auto flex items-center justify-center gap-2 hover:bg-red-600 transition-colors"
              >
                <span className="w-2 h-2 bg-white rounded-full"></span>
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserFilters;
